/* eslint-disable no-useless-return */
/* eslint-disable no-unused-vars */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';

EDC.Animations.MoveAnimals2 = function (scene, animal) {
  this.scene = scene;
  this.animal = animal;
  this.movingTime = 15000 + Math.round(Math.random() * 12000);
  this.padding = 120;
  this.speed = 0;
  this.maxX = this.scene.game.config.width - this.padding * 2;
  this.direction = 1;
  this.angle = 3;
  this.tweenH = null;
  this.tweenwalk = null;
  this.continueJumping = true;
  this.frozen = false;
  return this;
};

EDC.Animations.MoveAnimals2.prototype.start = function () {
  this.move();
};

EDC.Animations.MoveAnimals2.prototype.move = function () {
  this.speed = this.maxX / this.movingTime;
  // eslint-disable-next-line max-len
  const currentDistance = this.direction === 1 ? this.maxX - this.animal.x : this.animal.x - this.padding;
  const neededTime = currentDistance / this.speed;

  const randomDistance = 20 + Math.round(Math.random() * 80);
  const targetX = this.direction === 1 ? this.maxX : this.padding;
  this.tweenH = this.scene.tweens.add({
    targets: this.animal,
    x: targetX,
    duration: neededTime,
    ease: 'Linear',
    onComplete: this.movementHorizontalComplete.bind(this),
  });
  this.tweenwalk = this.scene.tweens.add({
    targets: this.animal,
    angle: 3,
    duration: 60,
    ease: 'Sine.easeInOut',
    yoyo: true,
    onComplete: this.walkComplete.bind(this),
  });
  this.jump(this.continueJumping);
};

EDC.Animations.MoveAnimals2.prototype.movementHorizontalComplete = function () {
  this.direction *= -1;
  if (this.direction === 1) {
    this.animal.flipX = false;
  } else {
    this.animal.flipX = true;
  }
  this.speed = this.maxX / this.movingTime;
  // eslint-disable-next-line max-len
  const currentDistance = this.direction === 1 ? this.maxX - this.animal.x : this.animal.x - this.padding;
  const neededTime = currentDistance / this.speed;
  const targetX = this.direction === 1 ? this.maxX : this.padding;
  this.tweenH = this.scene.tweens.add({
    targets: this.animal,
    x: targetX,
    duration: neededTime,
    ease: 'Linear',
    onComplete: this.movementHorizontalComplete.bind(this),
  });
};

EDC.Animations.MoveAnimals2.prototype.walkComplete = function () {
  this.angle *= -1;
  this.tweenwalk = this.scene.tweens.add({
    targets: this.animal,
    angle: -3,
    duration: 60,
    ease: 'Sine.easeInOut',
    yoyo: true,
    onComplete: this.walkComplete.bind(this),
  });
};

EDC.Animations.MoveAnimals2.prototype.getRandomTime = function () {
  if (this.continueJumping) {
    this.tweenJump = this.scene.tweens.add({
      targets: this.animal,
      y: this.animal.y - 70,
      duration: 150,
      ease: 'Sine.easeInOut',
      yoyo: true,
      onComplete: this.jump.bind(this),
    });
  } else {
    return;
  }
};

EDC.Animations.MoveAnimals2.prototype.jump = function () {
  const rndTime = Math.round(Math.random() * 15000);
  this.scene.time.addEvent({ delay: rndTime, callback: this.getRandomTime, callbackScope: this });
};

EDC.Animations.MoveAnimals2.prototype.stop = function () {
  this.frozen = true;
  this.tweenH.pause();
  this.tweenwalk.pause();
  this.continueJumping = false;
};

EDC.Animations.MoveAnimals2.prototype.resume = function () {
  if (this.frozen) {
    this.tweenH.resume();
    this.animal.angle = 0;
    this.tweenwalk.resume();
    this.continueJumping = true;
  } else {
    return;
  }
};
export default EDC.Animations.MoveAnimals2;
